import React from "react";

const MostActiveClubs = () => {
  return <div>MostActiveClubs</div>;
};

export default MostActiveClubs;
